<app-action-form [item]="item" [slot]="slot" [form]="form">
	<div class="form-section app-margin-horizontal app-padding">
        <div class="form-group" [formGroup]="form">
            <app-select label="Vomited" placeholder="choose..." [items]="vomitingItems" [saveValue]="true" formControlName="vomiting"></app-select>
            <app-select label="Regurgitation" placeholder="Choose..." [items]="regurgitationItems" [saveValue]="true" formControlName="regurgitation"></app-select>
        </div>
        <app-common-action-controls [action]="action" [form]="form"></app-common-action-controls>
    </div>
</app-action-form>
